import { styled, RadioGroup } from '@cherre-frontend/ui';

export const RadioGroupStyled = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 30px;
  margin-top: 5px;
`;
